import { inject, injectable } from "inversify";
import { ApplicationInsights, Exception, SeverityLevel } from "@microsoft/applicationinsights-web";
import { DesignSystemConfig } from "../../configuration/designSystemConfig";
import { ILoggingService } from "../interfaces/loggingService";

@injectable()
class LoggingService implements ILoggingService {
    private appInsights: ApplicationInsights;
    private logLocally: boolean = false;
    constructor(
        @inject(DesignSystemConfig) protected designSystemConfig: DesignSystemConfig
    ) {
        this.appInsights = new ApplicationInsights({
            config: {
                connectionString: designSystemConfig.AppInsightsConnectionString,
                disableCookiesUsage: true
            }
        });

        if (designSystemConfig.AppInsightsLogLocally != null) {
            this.logLocally = designSystemConfig.AppInsightsLogLocally;
        }
    }

    public async StartPageViewTracking() {
        this.appInsights.trackPageView();
    };

    public async InitialiseAppInsights() {
        this.appInsights.loadAppInsights();
    };

    private async LogMessageOrException(errormessage: string, messagetype: SeverityLevel) {
        if (this.logLocally == true) {
            if (messagetype >= SeverityLevel.Error) {
                errormessage = 'Exception: ' + errormessage;
            }
            console.error(errormessage);
        }
        else {
            if (messagetype == SeverityLevel.Critical) {
                this.appInsights.trackException({ exception: new Error(errormessage)});
            }
            else {
                this.appInsights.trackTrace({
                    message: errormessage,
                    severityLevel: messagetype
                });
            }
        };
    };

    public async LogMessage(logmessage: string) {
        this.LogMessageOrException(logmessage, SeverityLevel.Information);
    };

    public async LogError(logmessage: string) {
        this.LogMessageOrException(logmessage, SeverityLevel.Error);
    };

    public async LogException(exceptionmessage: string) {
        this.LogMessageOrException(exceptionmessage, SeverityLevel.Critical);
    };

    public async EnableTrackingCookies() {
        this.appInsights.getCookieMgr().setEnabled(true);
        this.LogMessage('Enabled user performance tracking cookie for App Insights');
    };
}

export { LoggingService }